/**
 * @file オプション消去
 */
'use strict';

/**
 * @classname RemoveOptionView
 * @classdesc オプション消去
 */
export default class RemoveOptionView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {object} controller - コントローラー
	 */
	constructor($e, controller) {
		console.log('RemoveOptionView.constructor');
		this._$e = $e;
		this._controller = controller;
		this._productId = $e.attr('data-product-id');
		this._skuId = $e.attr('data-sku-id');
		this._$productId = $('#deleteProductId');
		this._$skuId = $('#deleteSkuId');
		$e.on('click', () => {this.onClick();});
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof RemoveOptionView
	 * @return {undefined}
	 */
	onClick() {
		console.log('RemoveOptionView.onClick');
		const $product = this._$e.closest('.list-item');
		this._$productId.val(this._productId);
		this._$skuId.val(this._skuId);
		$('#form-option-delete').submit();

	};
}
